/**
 * 1688 주문 직전 실시간 재고 판정 — 구매요청 주문 화면(logisreqpurchaseV0) checkLiveStock 에서 쓴다.
 * 순수 함수만 둔다(DOM·store·API 모름).
 *
 * 왜 따로 있나: 저장해 둔 specId 가 1688 실시간 옵션에 없으면 예전에는 재고 0 으로 쳤다.
 * 그런데 그건 대개 판매자가 옵션 이름을 바꾼 경우다(예: 「13-19（小美8mm）」 → 「13-19（小美8mm）201半钢」,
 * 이름이 바뀌면 specId 도 새로 생긴다). 실제 재고는 충분한데 「재고 부족」으로 보여서 원인을 못 찾았다.
 * ⇒ 「옵션이 바뀜」과 「진짜 재고 부족」을 갈라서 알려준다.
 */

/**
 * 바뀐 옵션의 새 이름 후보 — 저장된 옵션 값이 새 옵션 값에 그대로 들어 있으면 후보로 본다(이름 뒤에 덧붙인 경우).
 *
 * @param {string[]} wanted - 저장된 옵션 값(옵션1_중국어, 옵션2_중국어)
 * @param {Array} skus - 실시간 skus [{ specId, 옵션: [...], 재고 }]
 * @returns {Array} 후보 sku 목록
 */
export function renamedSkuCandidates (wanted, skus) {
  const want = (wanted || []).filter(Boolean)
  if (want.length === 0) return []
  return (skus || []).filter(s => {
    const v = (s.옵션 || []).filter(Boolean)
    return v.length === want.length && want.every(w => v.some(x => String(x).includes(w)))
  })
}

/**
 * 한 품목(같은 offerId_specId 묶음) 판정.
 *
 * @param {{ specId: string, qty: number, wanted?: string[] }} n - 요청 묶음
 * @param {{ 재고: number, skus: Array, error?: string }|undefined} info - 실시간 조회 결과
 * @returns {{ kind: 'ok'|'skip'|'renamed'|'short', stock?: number, sku?: object, candidates?: Array }}
 *   skip = 조회 실패라 막지 않음, renamed = 저장된 옵션이 1688 에 없음(옵션 이름 변경), short = 진짜 재고 부족
 */
export function judgeLiveStock (n, info) {
  if (!info || info.error) return { kind: 'skip' }
  if (!n.specId) {
    const stock = info.재고
    return stock < n.qty ? { kind: 'short', stock } : { kind: 'ok', stock }
  }
  const sku = (info.skus || []).find(s => String(s.specId) === String(n.specId))
  if (!sku) return { kind: 'renamed', candidates: renamedSkuCandidates(n.wanted, info.skus) }
  return sku.재고 < n.qty ? { kind: 'short', stock: sku.재고, sku } : { kind: 'ok', stock: sku.재고, sku }
}
